		<div id="navBar">
    		<ul class="nav">
    			<li id="logo">
    				<img src="assets/images/logo.png" alt="MTData">
				</li><!-- logo -->
				<a *ngIf="isAdmin" [routerLink]="['/admin/user/database']" routerLinkActive #rlaUser="routerLinkActive">
					<li [class.active]="rlaUser.isActive" >
						<svg class="icon">
							<use xlink:href="assets/iconography/symbol-defs.svg#icon-user"></use>
						</svg>
						<span>Admin Users</span>
					</li>
				</a>
				<a [routerLink]="['/admin/driver/database',0]" routerLinkActive #rlaDriver="routerLinkActive">
					<li [class.active]="isActive(['driver', 'driver-detail'])" >
						<svg class="icon">
							<use xlink:href="assets/iconography/symbol-defs.svg#icon-drivers"></use>
						</svg>
						<span>Drivers</span>
					</li>
				</a>
				<a *ngIf="isAdmin" [routerLink]="['/admin/carrier/database']" routerLinkActive #rlaCarrier="routerLinkActive">
					<li [class.active]="isActive(['carrier'])" >
						<svg class="icon">
							<use xlink:href="assets/iconography/symbol-defs.svg#icon-office"></use>
						</svg>
						<span>Transport Operators</span>
					</li>
				</a>
				<a *ngIf="isCarrierAdmin" [routerLink]="['/admin/carrier/overview', 0]" routerLinkActive #rlaCarrier="routerLinkActive">
					<li [class.active]="isActive(['carrier'])" >
						<svg class="icon">
							<use xlink:href="assets/iconography/symbol-defs.svg#icon-office"></use>
						</svg>
						<span>Transport Operator</span>
					</li>
				</a>
				<a *ngIf="isAdmin" [routerLink]="['/admin/record-keeper/database']" routerLinkActive #rlaRecordKeeper="routerLinkActive">
					<li [class.active]="rlaRecordKeeper.isActive" >
						<svg class="icon">
							<use xlink:href="assets/iconography/symbol-defs.svg#icon-operator"></use>
						</svg>
						<span>Record Keepers</span>
					</li>
				</a>
				<a *ngIf="isAdminProvider" [routerLink]="['/admin/external-api-user/database']" routerLinkActive #rlaExternalApiUser="routerLinkActive">
					<li [class.active]="rlaExternalApiUser.isActive" >
						<svg class="icon">
							<use xlink:href="assets/iconography/symbol-defs.svg#icon-usb"></use>
						</svg>
						<span>External API Users</span>
					</li>
				</a>
				<a *ngIf="isAdminProvider" [routerLink]="['/admin/provider/database']" routerLinkActive #rlaProvider="routerLinkActive">
					<li [class.active]="rlaProvider.isActive" >
						<svg class="icon">
							<use xlink:href="assets/iconography/symbol-defs.svg#icon-technician"></use>
						</svg>
						<span>Providers</span>
					</li>
				</a>
				<!--maximum nav items is 5-->
    		</ul><!-- nav -->
    		<div id="leftDragBar" class="dragBar"></div>
		</div><!-- navBar -->
		<div id="content">
			<header>
				<div id="toolBar">
					<div class="tools">
						<div class="toolGroup">
							<breadcrumb></breadcrumb>
						</div>
						<div class="toolGroup">
							<div id="profile" tabindex="0" class="expandableTool simple">
								<div class="tool">
									<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-user"></use></svg>
								</div>
								<div class="toolSelect rightAlign">
									<ul>
										<li>
										<p>Hello, <strong>{{name}}</strong></p>
										</li>
										<div class="lineBreak"></div>
										<!-- <a href="#/login">
											<li>
												<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-user"></use></svg> View profile
											</li>
										</a>
										<a href="">
											<li>
												<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-cog"></use></svg> User settings
											</li>
										</a>										 -->
										<a href="#/login" >
											<li>
												<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-exit"></use></svg> Log Out
											</li>
										</a>
									</ul>
								</div>
							</div>
							<div id="help" tabindex="0" class="expandableTool simple">
								<div class="tool">
									<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-maintenance"></use></svg>
								</div>
								<div class="toolSelect rightAlign">
									<ul>
										<li>
											<a [routerLink]="" (click)="showHelp()">
												<li>
													<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-question"></use></svg> Help
												</li>
											</a>
										</li>
										<div class="lineBreak"></div>
										<li>
												<a [routerLink]="" (click)="showAbout()">
												<li>
													<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-information"></use></svg> About
												</li>
											</a>
										</li>
									</ul>
								</div>

							</div>
							<div id="themes" tabindex="0" class="expandableTool simple">
								<div class="theme preview"></div>
								<div class="toolSelect">
									<ul id="themeChoices">
										<li>
											<div id="light" class="theme">
												<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-tick"></use></svg>
											</div>
										</li>
										<li>
											<div id="dark" class="theme">
												<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-tick"></use></svg>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>

			<router-outlet></router-outlet>
		</div>
